import { EventEmitter, Injectable, Output } from '@angular/core';
import { API_METHODS, API_URL, OperationType } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { DataService } from '../../base-data-services/data.service';
import { environment } from 'src/environments/environment';
import { UnassignInternshipModel } from 'common/models/page-models/Student Internship List/Unassign-Internship/unassign-internship-data.model';
import { FormDataService } from '../Intership-List/intership-filter-form-data.service';

@Injectable()
export class InternshipDeleteDataService extends FormDataService<UnassignInternshipModel> {

    @Output() emitResultGrid = new EventEmitter<any>();
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.deleteInternship, http, ss);
  }

  override getEditUrlAndMethod() {
      const edit = {
        url: environment.apiUrl + API_URL.deleteInternship,
        method: API_METHODS.post
      }
      return edit;
    }
  
    override modifyAPIResponse(response: any) {
      return response['details'];
    }  

    override modifyPostModel(formModel: any, dataModel: any) {
      // formModel.id = this.ss.student_id;
      const submitData : any = {}
      submitData.id = formModel.id;
      submitData.internshipTerminatedReason = formModel.internshipTerminatedReason;
      return submitData;
    }
  

  createInstance(): UnassignInternshipModel {
    return new UnassignInternshipModel();
  }

   override afterPostData(model: UnassignInternshipModel, result?: any): Promise<UnassignInternshipModel> {
      return new Promise<UnassignInternshipModel>((resolve, reject) => {
        this.emitResultGrid.emit(result)
        resolve(this.transformAPIData(model));
      });
    }
  

  override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
    return environment.apiUrl + this.getAPI_URL();
  }
}